import { FC } from 'react';
import dayjs from 'dayjs';

import { Box, Typography } from '@thirdspacelearning/library';
import { SessionDoneDecoration } from '@assets/dashboard';

interface Props {
    sessionPlannedAt: dayjs.Dayjs | null;
}

const SessionDone: FC<Props> = ({ sessionPlannedAt }) => {
    return (
        <Box
            width="100%"
            display="flex"
            flexGrow={1}
            alignItems="center"
            justifyContent="space-between"
            pl={4}
        >
            <Box>
                <Typography
                    variant="h5"
                    fontWeight="bold"
                    data-testid="sessionDoneText"
                >
                    Session done - way to go!
                </Typography>
                {sessionPlannedAt && (
                    <Typography variant="h6" data-testid="sessionPlannedAtText">
                        Your next scheduled session is on{' '}
                        {sessionPlannedAt.format(' dddd, Do MMMM [at] h:mma')}.
                        See you there!
                    </Typography>
                )}
            </Box>

            <Box display="flex" overflow="hidden" height="110px">
                <SessionDoneDecoration />
            </Box>
        </Box>
    );
};

export default SessionDone;
